export const ACTIONS = {
  HANDLE_SUCCESS_GET_SUBSCRIPTIONS: 'handleSuccessGetSubscriptions',
  FETCHING_SUBSCRIPTIONS: 'fetchingSubscriptions',
  HANDLE_SUCCESS_GET_SUBSCRIPTION_PLANS: 'handleSuccessGetSubscriptionPlans',
  FETCHING_SUBSCRIPTION_PLANS: 'fetchingSubscriptionPlans',
  // list a user's subscriptions
  USER_SUBSCRIPTIONS_FETCH_START: 'USER_SUBSCRIPTIONS_FETCH_START',
  USER_SUBSCRIPTIONS_FETCH_SUCCESS: 'USER_SUBSCRIPTIONS_FETCH_SUCCESS',
  USER_SUBSCRIPTIONS_FETCH_FAILURE: 'USER_SUBSCRIPTIONS_FETCH_FAILURE',
  USER_SUBSCRIPTIONS_FETCH_RESET: 'USER_SUBSCRIPTIONS_FETCH_RESET',

  //  activate a subscription by id
  USER_SUBSCRIPTION_ACTIVATE_START: 'USER_SUBSCRIPTION_ACTIVATE_START',
  USER_SUBSCRIPTION_ACTIVATE_SUCCESS: 'USER_SUBSCRIPTION_ACTIVATE_SUCCESS',
  USER_SUBSCRIPTION_ACTIVATE_FAILURE: 'USER_SUBSCRIPTION_ACTIVATE_FAILURE',

  // cancel a subscription by id
  USER_SUBSCRIPTION_CANCEL_START: 'USER_SUBSCRIPTION_CANCEL_START',
  USER_SUBSCRIPTION_CANCEL_SUCCESS: 'USER_SUBSCRIPTION_CANCEL_SUCCESS',
  USER_SUBSCRIPTION_CANCEL_FAILURE: 'USER_SUBSCRIPTION_CANCEL_FAILURE',

  // reset feedback (success / error) after showing in UI
  USER_SUBSCRIPTION_OPERATION_FEEDBACK_RESET: 'USER_SUBSCRIPTION_OPERATION_FEEDBACK_RESET',
};
